import React from 'react';
import { motion } from 'framer-motion';
import RoomCard from '../components/RoomCard';
import rooms from '../data/rooms';

const Rooms = () => {
  return (
    <div className="py-16 bg-highlight">
      <div className="max-w-7xl mx-auto px-4">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-primary mb-4">Our Luxurious Rooms</h1>
          <p className="text-xl text-secondary max-w-2xl mx-auto">
            Experience unparalleled comfort and elegance in our meticulously designed rooms, each offering breathtaking views and premium amenities.
          </p>
        </motion.div>
        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          {rooms.map(room => (
            <RoomCard key={room.id} room={room} />
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default Rooms;